import { HttpUrlEncodingCodec } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Optional,
  Output,
  PLATFORM_ID,
  QueryList,
  SimpleChanges,
  ViewChildren
} from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CmsService, Product, ProductSearchPage, ProductService, SortModel } from '@spartacus/core';
import { BehaviorSubject, combineLatest, Observable, of, Subject } from 'rxjs';
import { catchError, distinctUntilChanged, filter, map, switchMap, take, takeUntil } from 'rxjs/operators';
import { isPlatformBrowser, isPlatformServer, Location, ViewportScroller } from '@angular/common';
import deepEqual from 'deep-equal';
import { Response } from 'express';
import { TranslatePipe } from '@ngx-translate/core';
import { IFilter, IOrder, SdFiltersComponent } from '@seb/web-design-system/filters';
import { SdProductCardComponent } from '@seb/web-design-system/product-card';
import { SdPaginationComponent } from '@seb/web-design-system/pagination';
import { SdProductSellerModalComponent } from '@seb/web-design-system/product-seller';
import {
  BrandsEnum,
  BrandThemesEnum,
  DeviceService,
  IProductCard, IPushCard,
  IPushCardWithLayout, IRangeOptions, ISdFormComponentItem, ISliderInfo,
  ITag, PositionEnum, PushSizeEnum,
  ScrollSpyService, SdPushCardComponent, SdTitleComponent, SizesEnum
} from '@seb/web-design-system/core';
import {
  ProductNotificationModalComponent
} from '../../../components/static/product-notification-modal/product-notification-modal.component';
import {
  OmnibusRecommendedPriceModalComponent
} from '../../../components/static/omnibus-recommended-price-modal/omnibus-recommended-price-modal.component';
import {
  Bundle,
  ComparedProductCard, CustomBaseStore, CustomCategory,
  CustomFacet,
  EventProductOrBundle,
  productCardSkeleton, PushCardComponentInterface, WC_CONFIG_PROVIDER, WcConfig
} from '../../../models';
import { CartGroupTypeEnum, PdpTypeEnum, ProductScopeEnum, StockAvailabilityEnum, StockStatusEnum } from '../../../enums';
import { BundleMapper, ProductMapper, PushCardMapper } from '../../../mappers';
import {
  BaseStoreService, BundleService, CartFacadeService, CategoryService, ComponentService,
  CustomProductListComponentService, DatalayerService, GlobalSearchService,
  PaginationComponentService, ProductComparatorService, StockService,
  TrackingService
} from '../../../services';
import { SERVER_RESPONSE } from '../../../constants';
import { CustomJsonLdDirective } from '../../../directives';
import { areAllQueryParamMapEqual, areQueryParamMapEqual, getPdpType } from '../../../utils';
import { SiblingCategoriesComponent } from '../sibling-categories/sibling-categories.component';

export interface ListCard {
  push?: IPushCardWithLayout;
  product?: IProductCard;
  type: 'product' | 'bundle' | 'push';
  id: string;
}

export interface PushWithId {
  push: IPushCardWithLayout;
  id: string;
}

export interface SuperFilter {
  label: string;
  value: boolean;
  query?: string;
  removeQuery?: string;
  code?: string;
}

@Component({
  selector: 'wc-product-card-grid',
  templateUrl: './product-card-grid.component.html',
  standalone: true,
  imports: [
    SdFiltersComponent,
    SdProductCardComponent,
    SdPushCardComponent,
    SdPaginationComponent,
    SdProductSellerModalComponent,
    ProductNotificationModalComponent,
    OmnibusRecommendedPriceModalComponent,
    CustomJsonLdDirective,
    TranslatePipe,
    SdTitleComponent,
    SiblingCategoriesComponent
  ]
})
export class ProductCardGridComponent implements OnInit, OnChanges, OnDestroy {
  @Input() brandCorner: BrandsEnum;

  @Input() currentCategory: string;

  @Input() currentCategoryCode: string;

  @Input() isGlobal = false;

  @Input() disableProductComparator = false;

  @Input() productGridTitleLevel = 4;

  @Input() isCategoryPage: boolean;

  @Input() isLoading = true;

  @Input() context: string;

  @Input() isAccessories = false;

  @Output() hasLoaded = new EventEmitter<void>();

  @ViewChildren('pushCardComponent', { read: ElementRef })
  pushsCardComponent: QueryList<ElementRef>;

  isMobile = false;
  currentPageType: PdpTypeEnum;
  pdpTypeEnum = PdpTypeEnum;

  isSis = false;

  currentPage = 0;
  sizesEnum = SizesEnum;
  linkUrl = '';

  pagination = {
    size: 9,
    totalElements: 0,
    totalPages: 0,
    currentPage: -1
  };

  categoryData: CustomCategory;
  jsonLdData: any;
  isSSR = true;

  isProductsInComparator: { [code: string]: boolean } = {};
  comparedProducts: ComparedProductCard[];

  cards: ListCard[] = [];
  orderInCategories = [];
  skeletonCards = new Array(3).fill(productCardSkeleton);
  hasNext = false;
  orderByValues: IOrder;
  priceRange: IRangeOptions;
  currentPriceRange: IRangeOptions;
  filters: IFilter[] = [];
  currentFilters: IFilter[] = [];
  pushSizeEnum = PushSizeEnum;
  totalProducts: number;
  brandEnum = BrandsEnum;

  isPush1Promo = false;
  isPush2Promo = false;

  promotionPush1HasBeenViewed = false;
  promotionPush2HasBeenViewed = false;

  notifyModalOpened = false;

  notifyProduct = '';

  notifyProductName = '';

  promotionName1: string;
  promotionName2: string;

  isOpenedSellerModal = false;

  productsToTrack: EventProductOrBundle[] = [];

  productCardListHasBeenViewed = false;
  superFilters: SuperFilter[] = [];

  categoryPageChanged = false;

  pageParams: Params;

  priceRangeQuery;

  pushCount = 0;

  isOpenedRecommendedModal = false;

  cartGroupTypeEnum = CartGroupTypeEnum;
  isNewPriceManagementActivated: boolean;

  positionEnum = PositionEnum;
  brandThemesEnum = BrandThemesEnum;
  protected readonly destroy$: Subject<void> = new Subject();
  protected readonly page$: Subject<number> = new BehaviorSubject(0);

  private products: Product[] = [];
  private bundles: Bundle[] = [];
  private pushs: PushWithId[] = [];
  private pageSize = 9;
  private totalPages = 0;
  private readonly quickFilterType = 'QUICK_FILTERS';
  private isPriceFiltered = false;
  private target: string;
  private baseStore: CustomBaseStore;

  constructor(
    private productMapper: ProductMapper,
    private productListComponentService: CustomProductListComponentService,
    private deviceService: DeviceService,
    private productComparatorService: ProductComparatorService,
    private cdRef: ChangeDetectorRef,
    private elRef: ElementRef,
    private route: ActivatedRoute,
    private globalSearchService: GlobalSearchService,
    private readonly cartFacadeService: CartFacadeService,
    private readonly cmsService: CmsService,
    private readonly pushCardMapper: PushCardMapper,
    private readonly bundleMapper: BundleMapper,
    private router: Router,
    private categoryService: CategoryService,
    private scrollSpyService: ScrollSpyService,
    private trackingService: TrackingService,
    private datalayerService: DatalayerService,
    private bundleService: BundleService,
    private componentService: ComponentService,
    private baseStoreService: BaseStoreService,
    private viewportScroller: ViewportScroller,
    private location: Location,
    private paginationComponentService: PaginationComponentService,
    private readonly productService: ProductService,
    private readonly stockService: StockService,
    @Inject(WC_CONFIG_PROVIDER) protected wcConfig: WcConfig,
    @Inject(PLATFORM_ID) protected platformId: any,
    @Optional() @Inject(SERVER_RESPONSE) private serverResponse: Response
  ) {
    this.baseStore = this.baseStoreService.baseStore;
  }

  private static mapOrderBy(sorts: SortModel[]): IOrder {
    const items = sorts ?? [];
    const orderBy: IOrder = {};
    orderBy.items = items;
    orderBy.valueKey = 'code';
    orderBy.libelleKey = 'name';
    orderBy.orderBy = items.find((sort) => sort.selected);
    return orderBy;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isLoading']?.currentValue) {
      this.totalProducts = undefined;
    }
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.viewportScroller.setOffset([0, 200]);
    }
    this.paginationComponentService.getUrlWithParams().subscribe((result) => {
      this.linkUrl = result;
    });
    combineLatest([
      this.route.queryParamMap,
      this.route.url,
      this.deviceService.isMobile,
      this.cmsService.getContentSlot('ProductGrid'),
      this.cmsService.getCurrentPage(),
      this.categoryService.getCurrentCategory()
    ])
      .pipe(
        distinctUntilChanged(
          (
            [previousQueryParams, previousUrls, previousIsMobile, previousComponent],
            [currentQueryParams, currentUrls, currentIsMobile, currentComponent]
          ) => {
            if (
              !previousUrls
                .map((url) => url.path)
                .every((previousPath) => currentUrls.map((url) => url.path).indexOf(previousPath) !== -1)
            ) {
              this.categoryPageChanged = true;
              this.paginationComponentService.getUrlWithParams().subscribe((result) => {
                this.linkUrl = result;
              });
            }
            if (this.isGlobal) {
              if (previousQueryParams.get('page') !== currentQueryParams.get('page')) {
                return false;
              }
              return (
                ((areAllQueryParamMapEqual(previousQueryParams, currentQueryParams, [
                  'query',
                  'sortCode',
                  'target',
                  'currentPage'
                ]) ||
                  (!previousQueryParams.has('sortCode') &&
                    currentQueryParams.has('sortCode') &&
                    areAllQueryParamMapEqual(previousQueryParams, currentQueryParams, [
                      'query',
                      'target',
                      'sortCode',
                      'currentPage'
                    ])) ||
                  (previousQueryParams.has('sortCode') &&
                    !currentQueryParams.has('sortCode') &&
                    areAllQueryParamMapEqual(previousQueryParams, currentQueryParams, [
                      'query',
                      'target',
                      'currentPage'
                    ]))) &&
                  deepEqual(previousUrls, currentUrls) &&
                  previousIsMobile === currentIsMobile) ||
                currentQueryParams.keys?.length === 0
              );
            } else {
              if (previousComponent !== currentComponent) {
                this.currentPage = 0;
                return false;
              }
              return (
                (areQueryParamMapEqual(previousQueryParams, currentQueryParams, 'sortCode') &&
                  deepEqual(previousUrls, currentUrls) &&
                  previousIsMobile === currentIsMobile) ||
                (!previousQueryParams.has('sortCode') && currentQueryParams.has('sortCode')) ||
                (currentQueryParams.keys?.length === 0 && !/\/c\/|\/csc\//.test(window?.location.href))
              );
            }
          }
        ),
        switchMap(([queryParamsMap, urls, isMobile, components, _page, category]) => {
          const url = this.route?.snapshot?.url?.[0]?.path;
          this.currentPageType = getPdpType(url);
          this.categoryData = category;
          let componentDatas$: Observable<PushCardComponentInterface>[];
          if (components.components?.length > 0) {
            componentDatas$ = components.components.map((innerComponent) =>
              this.cmsService.getComponentData(innerComponent.uid).pipe(
                filter((cmp) => !!cmp),
                switchMap((cmp) => this.componentService.getLazyComponentData(cmp, 'links'))
              )
            );
          } else {
            componentDatas$ = [];
          }
          const cPage = queryParamsMap.has('page') ? parseInt(queryParamsMap.get('page')) - 1 : null;
          this.target = queryParamsMap.has('target') ? queryParamsMap.get('target') : 'product';
          if (
            !this.target ||
            (queryParamsMap.has('target') && this.target === queryParamsMap.get('target')) ||
            this.target === queryParamsMap.get('target') ||
            !queryParamsMap.has('target') ||
            !this.isGlobal
          ) {
            this.isMobile = isMobile;
            this.isSis = urls?.length > 2 ? urls[urls.length - 2].path.includes('csc') : false;
            if (this.isSis) {
              this.pageSize = 15;
            } else {
              this.pageSize = 9;
            }
            this.pageSize = this.pageSize - componentDatas$.length;
            this.productListComponentService.setDefaultPageSize(this.pageSize);
            this.target = queryParamsMap.has('target') ? queryParamsMap.get('target') : 'product';
            const queryParams = this.route.snapshot.queryParams;
            this.pageParams = {
              ...queryParams,
              currentPage: cPage,
              target: this.target,
              pageSize: this.pageSize
            };
            const result$ = this.isGlobal
              ? this.globalSearchService
                .globalSearch(this.pageParams)
                .pipe(
                  map((search) =>
                    search.productSearchPageData
                      ? search.productSearchPageData
                      : search.accessorySearchPageData
                        ? search.accessorySearchPageData
                        : search.ifuSearchPageData
                  )
                )
              : this.isSis
                ? this.categoryService.getProductsCategorySis(cPage, this.pageSize)
                : this.productListComponentService.model$;
            return combineLatest([result$, ...componentDatas$]).pipe(
              filter(
                ([result, ...componentData]: [
                  ProductSearchPage,
                  PushCardComponentInterface
                ]) => {
                  return !!result && !!componentData;
                }
              ),
              distinctUntilChanged((prevData, currData) => {
                const prevSearchPage = prevData[0];
                const currSearchPage = currData[0];
                this.currentPriceRange = this.mapPriceSlider(currSearchPage?.facets);
                this.currentFilters = this.mapFilters(currSearchPage?.facets);
                return (
                  prevSearchPage.currentQuery?.query?.value === currSearchPage.currentQuery?.query?.value &&
                  prevSearchPage.pagination.currentPage === currSearchPage.pagination.currentPage &&
                  prevSearchPage.pagination.totalPages === currSearchPage.pagination.totalPages
                );
              })
            );
          } else {
            return of([]);
          }
        }),
        takeUntil(this.destroy$)
      )
      .subscribe(([searchPage, ...componentData]) => {
        this.isNewPriceManagementActivated = this.baseStore.activateNewPriceManagement;
        if (isPlatformServer(this.platformId) && searchPage?.products?.length === 0) {
          this.serverResponse.status(410);
        }
        if (componentData) {
          this.isPush1Promo = componentData[0]?.isPushPromo ? JSON.parse(componentData[0]?.isPushPromo) : false;
          this.isPush2Promo = componentData[1]?.isPushPromo ? JSON.parse(componentData[1]?.isPushPromo) : false;
          if (componentData[0]) {
            this.promotionName1 = componentData[0].headline;
          }
          if (componentData[1]) {
            this.promotionName2 = componentData[1].headline;
          }
        }
        this.pushs = componentData?.slice(0, 2).map((component, index) => ({
          id: index.toString(),
          push: this.pushCardMapper.toPushCardWithLayout(component)
        }));
        this.pushCount = this.pushs?.length;
        if (this.categoryPageChanged) {
          this.superFilters = [];
          this.categoryPageChanged = false;
          this.priceRange = undefined;
          this.isPriceFiltered = false;
        }
        this.priceRange = !this.isPriceFiltered ? this.currentPriceRange : this.priceRange;
        if (this.categoryPageChanged || !this.priceRange) {
          this.priceRange = this.mapPriceSlider(searchPage?.facets);
        }
        this.filters = this.currentFilters.length > 0 ? this.currentFilters : this.mapFilters(searchPage?.facets);
        if (!searchPage?.freeTextSearch) {
          this.mapSuperFilter(searchPage);
        }
        this.currentPage =
          searchPage.pagination.currentPage !== undefined ? searchPage.pagination.currentPage : this.currentPage;
        this.totalProducts = searchPage.pagination.totalResults;
        this.totalPages = searchPage.pagination.totalPages;

        const isReviewActivated = this.baseStore.ratingAndReviewsIdWebsite;
        const updatedProducts = [];
        if (!isReviewActivated) {
          for (let i = 0; i < searchPage.products?.length; i++) {
            updatedProducts.push({
              ...searchPage.products[i],
              gsebAverageRating: null,
              gsebNumberOfReviews: null
            });
          }
        } else {
          for (let i = 0; i < searchPage.products?.length; i++) {
            updatedProducts.push({
              ...searchPage.products[i],
              gsebAverageRating: searchPage.products[i]?.productGenre !== 'Forfait'
                ? searchPage.products[i]?.gsebAverageRating
                : null,
              gsebNumberOfReviews: searchPage.products[i]?.productGenre !== 'Forfait'
                ? searchPage.products[i]?.gsebNumberOfReviews
                : null
            });
          }
        }
        this.pagination = searchPage.pagination;
        this.products.push(...updatedProducts);

        const categories = this.mapOrderInCategories(updatedProducts);
        if (!this.orderInCategories?.find((item) => item?.code === categories[0]?.code)) {
          this.orderInCategories.push(...categories);
        }

        this.checkIsInComparator(updatedProducts);

        this.addCards(updatedProducts);

        const hasLowStockProducts = updatedProducts.some((product) => product.stock?.stockLevelStatus === StockStatusEnum.LOW_STOCK);
        if (hasLowStockProducts) {
          this.trackingService.sendEvent(
            'productListView',
            { productAvailability: StockAvailabilityEnum.LOW_STOCK }
          );
        }

        const hasFilters = this.filters.filter((filter) => {
          const filterHasAtLeastOneChecked = filter?.values.filter((value) => value.checked);
          return filterHasAtLeastOneChecked.length > 0 ? filter : null;
        });
        if (!(hasFilters?.length > 0) && !this.isPriceFiltered && !(this.superFilters?.length > 0)) {
          this.jsonLdData = this.generateJsonLdData(updatedProducts);
        }
        this.orderByValues = ProductCardGridComponent.mapOrderBy(searchPage.sorts);
        this.datalayerService.setProductList(this.products, this.pushCount);
        this.cdRef.markForCheck();
      });

    this.productComparatorService.products$.pipe(takeUntil(this.destroy$)).subscribe((comparedProducts) => {
      this.comparedProducts = comparedProducts;
      this.checkIsInComparator(this.products);
    });
  }

  generateJsonLdData(updatedProducts) {
    const itemListElement = [];
    updatedProducts.forEach((updatedProduct, index) => {
      const brandName = updatedProduct?.brand;
      const item = {
        '@type': 'Product',
        brand: {
          '@type': 'Brand',
          name: brandName
        },
        position: index + 1,
        image: updatedProduct?.images?.PRIMARY?.main?.originalUrl ?? '',
        url: updatedProduct?.url ?? '',
        name: updatedProduct?.name ?? '',
        offers: {
          '@type': 'Offer',
          priceCurrency: updatedProduct?.price?.currencyIso ?? '',
          price: updatedProduct?.price?.value ?? 0
        },
        aggregateRating: updatedProduct?.gsebAverageRating
          ? {
            '@type': 'AggregateRating',
            ratingValue: updatedProduct?.gsebAverageRating ?? 0,
            reviewCount: updatedProduct?.gsebNumberOfReviews ?? 0
          }
          : null
      };
      itemListElement.push(item);
    });
    const jsonLdData = {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      url: this.linkUrl.split('?')[0],
      numberOfItems: updatedProducts.length,
      itemListElement
    };
    return jsonLdData;
  }

  getPage(event: ISliderInfo): void {
    const page = event?.index;
    this.currentPage = event?.index;
    if (this.isGlobal) {
      this.searchPage(page);
    } else if (this.isSis) {
      this.categoryService.goToPage(page, this.pageSize);

      const simpleLinkUrl = this.linkUrl.includes('?page=')
        ? this.linkUrl.replace('?page=', '')
        : this.linkUrl.replace('&page=', '');
      const redirectUrl = this.currentPage ? this.linkUrl + (this.currentPage + 1) : simpleLinkUrl;
      this.location.replaceState(redirectUrl);
    } else {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          page: page ? page + 1 : null
        },
        queryParamsHandling: 'merge'
      });
    }
  }

  searchPage(currentPage: number): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        page: currentPage ? currentPage + 1 : null
      },
      queryParamsHandling: 'merge'
    });
  }

  onSelectedFilters(selectedFilter: ISdFormComponentItem): void {
    const selectedFilterValue = selectedFilter?.value.toString();
    if (selectedFilterValue) {
      if (selectedFilterValue === 'PRICE_RANGE') {
        const searchQuery: string = this.route.snapshot.queryParams['query'];
        const decodedValue = new HttpUrlEncodingCodec()
          .decodeValue(searchQuery)
          .replace(RegExp(`:${this.priceRangeQuery.split(':').slice(-2)[0]}:\\[\\S+ TO \\S+\\]`), '');
        this.productListComponentService.setQuery(decodedValue);
        return;
      } else {
        if (selectedFilter?.checked) {
          this.trackingService.sendEvent('facetedSearch', {
            facetFilterName: selectedFilter?.nameField,
            facetFilterCriteria: selectedFilter?.libelle
          });
        }
      }
      const decodedValue = new HttpUrlEncodingCodec().decodeValue(
        this.isGlobal
          ? selectedFilterValue
          : selectedFilterValue.replaceAll(/\+/g, ' ')
      );
      this.productListComponentService.setQuery(decodedValue);
    } else {
      const flagshipQuery = this.route.snapshot.queryParams['query']
        ?.split('flagshipProduct:')
        ?.filter((query) => query.includes('FlagshipProduct'))[0]
        ?.split(':')[0];
      let searchQuery = this.route.snapshot.queryParams['query']?.split(':')[0];
      if (flagshipQuery) {
        searchQuery = searchQuery + ':default:flagshipProduct:' + flagshipQuery;
      }
      this.superFilters = (this.superFilters || []).map((f) => ({ ...f, value: false }));
      this.productListComponentService.setQuery(searchQuery);
    }
  }

  onSortSelected(sortBy: string): void {
    const sortByStatus = this.orderByValues.items.find((sort) => sort.code === sortBy)?.selected;
    if (!!sortBy && sortBy !== this.route.snapshot.queryParams['sortCode'] && !sortByStatus) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          sortCode: sortBy === 'default' ? undefined : sortBy,
          page:
            !this.route.snapshot.queryParams['sortCode'] && this.route.snapshot.queryParams['page']
              ? this.route.snapshot.queryParams['page']
              : null
        },
        queryParamsHandling: 'merge'
      });
      this.trackingService.sendEvent('clickSort', {
        sortName: sortBy.charAt(0).toUpperCase() + sortBy.split('-')[0].slice(1)
      });
    }
  }

  onSelectedPriceRange(event) {
    this.isPriceFiltered = true;
    const minVal = parseFloat(event.min);
    const maxVal = parseFloat(event.max);
    const searchQuery: string = this.route.snapshot.queryParams['query'];
    const priceQuery = this.priceRangeQuery.split(':').slice(0, -1).join(':');
    const priceQueryName = this.priceRangeQuery.split(':').slice(-2)[0];
    if (!searchQuery) {
      this.productListComponentService.setQuery(
        new HttpUrlEncodingCodec().decodeValue(`${priceQuery}:[${minVal} TO ${maxVal}]`)
      );
    } else if (searchQuery.includes(priceQueryName)) {
      this.productListComponentService.setQuery(
        new HttpUrlEncodingCodec().decodeValue(
          searchQuery.replace(
            RegExp(`${priceQueryName}:\\[\\S+ TO \\S+\\]`),
            `${priceQueryName}:[${minVal} TO ${maxVal}]`
          )
        )
      );
    } else {
      this.productListComponentService.setQuery(
        new HttpUrlEncodingCodec().decodeValue(
          `${searchQuery}:${this.priceRangeQuery.split(':').slice(-2)[0]}:[${minVal} TO ${maxVal}]`
        )
      );
    }
  }

  addOrRemoveToComparator(isAdd: boolean, productCard: IProductCard): void {
    const simpleLinkUrl = this.linkUrl.includes('?page=')
      ? this.linkUrl.replace('?page=', '')
      : this.linkUrl.replace('&page=', '');
    const urlCategory = this.currentPage ? this.linkUrl + (this.currentPage + 1) : simpleLinkUrl;
    productCard['urlCategory'] = urlCategory;
    if (isAdd && isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.isProductsInComparator = {
          ...this.isProductsInComparator,
          [productCard.code]: this.productComparatorService.addProduct(productCard, this.orderInCategories)
        };
        this.cdRef.markForCheck();
      });
    } else {
      this.productComparatorService.removeProduct(productCard.code);
    }
  }

  addToCart(productCode: string): void {
    sessionStorage.setItem('addToCartContext', this.context);
    const currentProduct = this.products.find((product) => product.code === productCode);
    if (!currentProduct) {
      let currentBundle: Bundle;
      for (const product of this.products) {
        currentBundle = product.indexedBundles?.find((bundle) => bundle.id === productCode);
        if (currentBundle) {
          break;
        }
      }
      this.cartFacadeService.addBundleToCartShippingType(currentBundle, 1);
    } else {
      this.cartFacadeService.addToCartShippingType(currentProduct, 1);
    }
  }

  cleanCards(newCards: ListCard[]): void {
    this.cards = [];
    if (this.pushs?.length > 0) {
      newCards.splice(2, 0, { push: this.pushs[0].push, type: 'push', id: this.pushs[0].id });
      if (this.pushs.length > 1) {
        newCards.splice(5, 0, { push: this.pushs[1].push, type: 'push', id: this.pushs[1].id });
      }
    }
    this.cards = newCards;
    this.updateProductPriceCards();
    this.productCardListHasBeenViewed = false;
    this.hasNext = this.currentPage < this.totalPages - 1;
    this.hasLoaded.emit();
  }

  updateProductPriceCards() {
    if (isPlatformBrowser(this.platformId)) {
      const updateCardPrices$: Observable<ListCard>[] = this.cards
        .filter((card) => card.type === 'product')
        .map((card) =>
          this.productService.get(card.id, [ProductScopeEnum.PRICE, ProductScopeEnum.STOCK]).pipe(
            filter((p) => !!p),
            map((productData) => {
              const formattedPrices = this.productMapper.formatCardPrice(productData, this.isNewPriceManagementActivated);
              return {
                ...card,
                product: {
                  ...card.product,
                  price: formattedPrices?.price,
                  discountedPrice: formattedPrices?.discountedPrice,
                  recommendedPrice: formattedPrices?.recommendedPrice,
                  stock: {
                    ...card.product?.stock,
                    lowStock: this.stockService.checkStock(productData?.price?.value, productData?.stock?.stockLevel)
                  }
                }
              };
            })
          )
        );

      combineLatest(updateCardPrices$).pipe(
        take(1)
      ).subscribe((updatedCards: ListCard[]) => {
        const updatedCardsMap = new Map(updatedCards.map((card) => [card.id, card]));
        this.cards = this.cards.map((card) => {
          if (updatedCardsMap.has(card.id)) {
            return { ...card, ...updatedCardsMap.get(card.id) };
          }
          return card;
        });
        this.isSSR = false;
      });
    }
  }

  notifyMe(productCode: string): void {
    const currentProduct = this.products.find((product) => product.code === productCode);
    this.notifyProductName = currentProduct.name;
    this.notifyProduct = productCode;
    this.notifyModalOpened = true;
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    if (!this.productCardListHasBeenViewed && this.scrollSpyService.isElementActive(this.elRef)) {
      this.productCardListHasBeenViewed = true;
      this.trackProducts();
    }

    if (this.pushsCardComponent?.toArray()[0]) {
      if (
        !this.promotionPush1HasBeenViewed &&
        this.trackingService.checkingForPromoView(
          { nativeElement: this.pushsCardComponent?.toArray()[0].nativeElement },
          this.isPush1Promo,
          this.promotionName1
        )
      ) {
        this.promotionPush1HasBeenViewed = true;
      }
    }
    if (this.pushsCardComponent?.toArray()[1]) {
      if (
        !this.promotionPush2HasBeenViewed &&
        this.trackingService.checkingForPromoView(
          { nativeElement: this.pushsCardComponent?.toArray()[1].nativeElement },
          this.isPush2Promo,
          this.promotionName2
        )
      ) {
        this.promotionPush2HasBeenViewed = true;
      }
    }
  }

  onPromoClick(promoClicked: IPushCard): void {
    if (
      this.pushsCardComponent?.toArray()[0] &&
      promoClicked.richParagraph.heading.data.title === this.promotionName1 &&
      this.isPush1Promo
    ) {
      this.trackingService.onPromoClick(this.isPush1Promo, this.promotionName1);
    }
    if (
      this.pushsCardComponent?.toArray()[1] &&
      promoClicked.richParagraph.heading.data.title === this.promotionName2 &&
      this.isPush2Promo
    ) {
      this.trackingService.onPromoClick(this.isPush2Promo, this.promotionName2);
    }
  }

  openSellerModal(): void {
    this.isOpenedSellerModal = true;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onProductClick(productCodeClicked: string): void {
    if (this.cards.find((card) => card.id === productCodeClicked).type === 'product') {
      const currentProduct = this.products.find((product: Product) => product.code === productCodeClicked);
      this.trackingService.sendEvent(
        'productClick',
        this.trackingService.productToEventProduct(
          currentProduct,
          this.cards.findIndex((card) => card.id === productCodeClicked)
        )
      );
      if (currentProduct.stock?.stockLevelStatus === StockStatusEnum.LOW_STOCK) {
        this.trackingService.sendEvent(
          'productClick',
          { productAvailability: StockAvailabilityEnum.LOW_STOCK }
        );
      }
    }

    if (this.cards.find((card) => card.id === productCodeClicked).type === 'bundle') {
      const currentBundle = this.bundles.find((bundle: Bundle) => bundle.id === productCodeClicked);
      this.trackingService.sendEvent(
        'productClick',
        this.trackingService.bundleToEventProduct(
          currentBundle,
          this.cards.findIndex((card) => card.id === productCodeClicked)
        )
      );
    }
  }

  onSelectedSuperFilters(superFilter: SuperFilter): void {
    if (superFilter.value && superFilter.label) {
      this.trackingService.sendEvent('quickFacetedSearch', { facetFiltername: superFilter.label });
    }
    const searchQuery: string = this.route.snapshot.queryParams['query'];
    if (!searchQuery) {
      this.productListComponentService.setQuery(
        new HttpUrlEncodingCodec().decodeValue(superFilter.query.replace('+', ' '))
      );
    } else {
      if (searchQuery.includes(superFilter.code)) {
        this.productListComponentService.setQuery(
          new HttpUrlEncodingCodec().decodeValue(superFilter.removeQuery.replace('+', ' '))
        );
      } else {
        this.productListComponentService.setQuery(
          new HttpUrlEncodingCodec().decodeValue(superFilter.query.replace('+', ' '))
        );
      }
    }
  }

  private mapFilters(facets: CustomFacet[]): IFilter[] {
    const catFacetsValues = facets?.filter((facet) => facet['facetNavigationType'] === 'GAMMES')[0]?.values;
    return (facets ?? [])
      .filter((facet) => {
        if (
          this.categoryData?.promotion &&
          catFacetsValues?.filter((facetValue) => facetValue.selected === true).length === 0
        ) {
          return facet['facetNavigationType'] === 'GAMMES';
        } else {
          return facet['storeFrontDisplay'] !== 'SLIDER' && facet['facetNavigationType'] !== this.quickFilterType;
        }
      })
      .map((facet) => {
        return {
          ...facet,
          displayWidth: facet.displayWidth < 200 ? 200 : facet.displayWidth,
          hasAutocomplete: facet.storeFrontDisplay === 'AUTOCOMPLETE',
          values: facet.values.map((facetValue) => ({
            libelle: facetValue.name,
            checked: facetValue.selected,
            value: this.isGlobal ? facetValue.query.url.split('/search?q=')[1] : facetValue.query.query.value,
            count: facetValue.count
          }))
        };
      });
  }

  private mapOrderInCategories(products: Product[]): any[] {
    return (
      products?.map(({ code, orderInCategories, sisCategory }) => {
        if (this.isSis) {
          return { code, sisCategory };
        } else {
          return { code, ...orderInCategories?.map((item) => item?.split(':')[1]) };
        }
      }) ?? []
    );
  }

  private mapSuperFilter(searchPage): void {
    this.superFilters = (searchPage.facets || [])
      .filter(
        (facet) =>
          facet.storeFrontDisplay !== 'SLIDER' &&
          facet['facetNavigationType'] === this.quickFilterType &&
          facet.values.some((value) => value.name === 'true')
      )
      .map((facet) => ({
        label: facet.name,
        value: !!facet.values.filter((value) => value.name === 'true')[0].selected,
        query: facet.values.filter((value) => value.name === 'true')[0].query.query.value,
        code: `quickFilter${facet.name.replace(/\s/g, '')}`
      }));
    searchPage.breadcrumbs?.forEach((breadcrumb) => {
      if (breadcrumb.facetNavigationType === this.quickFilterType) {
        this.superFilters.push({
          label: breadcrumb.facetName,
          value: true,
          query: searchPage.currentQuery.query.value,
          code: breadcrumb.facetCode,
          removeQuery: breadcrumb.removeQuery.query.value
        });
      }
    });
  }

  private mapPriceSlider(facets) {
    if (!facets?.length) return undefined;
    const slider = facets?.filter(
      (facet) => facet.storeFrontDisplay === 'SLIDER' && facet['facetNavigationType'] === 'PRICE_RANGE'
    )[0];
    if (slider) {
      this.priceRangeQuery = slider.values[0].query?.query?.value;
      if (!this.isCategoryPage && this.wcConfig?.sliderCategoryOnly) {
        return undefined;
      }
      return {
        minValue: Math.floor(Number(slider.values[0]?.name)),
        minDefaultValue: Math.floor(Number(slider.values[0]?.name)),
        rangeTitle: slider.name || 'Price',
        maxValue: Math.ceil(Number(slider.values.slice(-1)[0]?.name)),
        maxDefaultValue: Math.ceil(Number(slider.values.slice(-1)[0]?.name)),
        step: 5,
        required: false,
        idMinField: slider.values[0]?.name,
        idMaxField: slider.values.slice(-1)[0]?.name,
        maxValueLabel: slider.values.slice(-1)[0]?.name,
        minValueLabel: slider.values[0]?.name
      };
    }
    return undefined;
  }

  private addCards(products: Product[]): void {
    const newCards: ListCard[] = [];
    const getBundlesWithProductsPrice: Observable<Bundle>[] = [];
    const getProductCards$: Observable<IProductCard>[] = [];

    products.forEach((product) => {
      getProductCards$.push(this.productMapper.productToProductCard(product, this.disableProductComparator));
      product.indexedBundles?.forEach((bundle) => {
        const bundle$: Observable<Bundle> = this.bundleService.getBundle(bundle.id);
        getBundlesWithProductsPrice.push(bundle$);
      });
    });

    const productCards$ =
      getProductCards$.length > 0
        ? combineLatest(getProductCards$).pipe(catchError(() => of(undefined)))
        : of(undefined);
    const bundlesWithProductsPrice$ =
      getBundlesWithProductsPrice.length > 0
        ? combineLatest(getBundlesWithProductsPrice).pipe(catchError(() => of(undefined)))
        : of(undefined);
    combineLatest([bundlesWithProductsPrice$, productCards$]).subscribe(
      ([bundlesWithProductsPrice, productCards]) => {
        productCards?.map((productCard) => {
          const _productCard: IProductCard = {
            ...productCard,
            ratings: !this.baseStore.activateRatingAndReviews ? null : productCard.ratings,
            subtitle: this.currentPageType === this.pdpTypeEnum.ACCESSORY ? null : productCard.subtitle,
            seller: this.currentPageType === this.pdpTypeEnum.ACCESSORY ? null : productCard.seller,
            tags: this.currentPageType === this.pdpTypeEnum.ACCESSORY
              ? null
              : this.isMobile
                ? this.checkTagsLength(productCard.tags, 19)
                : productCard.tags,
            isProductComparator: this.currentPageType === this.pdpTypeEnum.ACCESSORY ? null : productCard.isProductComparator
          };
          newCards.push({
            product: _productCard,
            type: 'product',
            id: productCard.code
          });
        });

        if (bundlesWithProductsPrice) {
          this.bundles = bundlesWithProductsPrice;
          this.bundles.forEach((bundle) => {
            this.bundleMapper.bundleToIProductCustomer({ ...bundle })
              .pipe(take(1), takeUntil(this.destroy$))
              .subscribe((cardBundle) => {
                if (
                  !bundlesWithProductsPrice
                    .find((bundleWithProductsPrice) => bundleWithProductsPrice.id === bundle.id)
                    ?.products?.every((p) => !!p.price)
                ) {
                  cardBundle.price = undefined;
                }
                if (
                  cardBundle?.stock?.online &&
                  bundlesWithProductsPrice
                    .filter((bundleWithProductsPrice) =>
                      bundleWithProductsPrice?.products?.every(
                        (productOfTheBundle) =>
                          productOfTheBundle.price?.value &&
                          productOfTheBundle.onSale &&
                          (productOfTheBundle.stock?.stockLevelStatus === StockStatusEnum.IN_STOCK ||
                            productOfTheBundle.stock?.stockLevelStatus === StockStatusEnum.LOW_STOCK)
                      )
                    )
                    .find((bundleWithProductsPrice) => bundleWithProductsPrice.id === bundle.id)
                ) {
                  const product = bundle?.products[0];
                  const productIndex = newCards.findIndex((card) => card.id === product.code);
                  newCards.splice(productIndex + 1, 0, {
                    product: {
                      ...cardBundle,
                      isTaxesIncluded: this.baseStore.displayTaxesIncluded
                    },
                    type: 'bundle',
                    id: bundle.id
                  });
                }
              });
          });
        }
        this.cleanCards(newCards);
      },
      () => {
        this.cleanCards(newCards);
      }
    );
  }

  private checkIsInComparator(products: Product[]): void {
    products.forEach((product) => {
      this.isProductsInComparator[product.code] = this.comparedProducts?.findIndex((p) => p.code === product.code) > -1;
    });
    this.cdRef.markForCheck();
  }

  private trackProducts() {
    const newProductsToTrack: EventProductOrBundle[] = [];
    this.cards.forEach((card: ListCard, index: number) => {
      if (
        card.type === 'product' &&
        this.productsToTrack.find((productToTrack) => productToTrack.productID === card.id) === undefined
      ) {
        const productToTrack: Product = this.products.find((product: Product) => product.code === card.id);
        const trackedProductInfos: EventProductOrBundle = this.trackingService.productToEventProduct(
          productToTrack,
          index
        );
        newProductsToTrack.push(trackedProductInfos);
        this.productsToTrack.push(trackedProductInfos);
      }
      if (
        card.type === 'bundle' &&
        this.productsToTrack.find((bundleToTrack) => bundleToTrack.productID === card.id) === undefined
      ) {
        const bundleToTrack = this.bundles.find((bundle: Bundle) => bundle.id === card.id);
        const trackedProductInfos = this.trackingService.bundleToEventProduct(bundleToTrack, index);
        newProductsToTrack.push(trackedProductInfos);
        this.productsToTrack.push(trackedProductInfos);
      }
    });
    this.trackingService.sendEvent('productListView', { productList: newProductsToTrack });
  }

  private checkTagsLength(tags: ITag[], maxChar): ITag[] {
    return tags.map((tag) => {
      return {
        ...tag,
        text: tag?.text.length > maxChar ? tag?.text.slice(0, maxChar) + '...' : tag?.text
      };
    });
  }

  onReviewsSeeAllClicked(product: IProductCard) {
    this.trackingService.sendEvent('clickSeeReviews', {
      productName: product.title,
      productID: product.code
    });
  }

  onClickedPage(index: number) {
    if (isPlatformBrowser(this.platformId)) {
      this.viewportScroller.scrollToAnchor('product-card-grid-filters');
    }
    this.trackingService.sendEvent('clickPagination', { paginationLevel: index });
    this.getPage({ index: index - 1, itemsPerView: this.pageSize });
  }

  openRecommendedPriceModal() {
    this.isOpenedRecommendedModal = true;
  }
}
